import { atom, RecoilState } from 'recoil';

export type ASRPlexWebSocketState = {
  socket: WebSocket | null;
  active_transaction_id: string;
};
export const asrPlexWebSocketState: RecoilState<ASRPlexWebSocketState> =
  atom<ASRPlexWebSocketState>({
    key: 'asrPlexWebSocket',
    default: {
      socket: null,
      active_transaction_id: '',
    },
  });

export const asrPlexVadWebSocketState: RecoilState<ASRPlexWebSocketState> =
  atom<ASRPlexWebSocketState>({
    key: 'asrPlexVadWebSocket',
    default: {
      socket: null,
      active_transaction_id: '',
    },
  });
